import { connect } from "react-redux";
import { langugae } from "../../config/languageJSON";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import ProductWiseSkuPdfHeader from "../Common/ProductWiseSkuPdf/components/ProductWiseSkuPdfHeader";
import ProductWiseSkuPdfTable from "../Common/ProductWiseSkuPdf/components/ProductWiseSkuPdfTable";
import { useProductWiseSkuPdfData } from "../Common/ProductWiseSkuPdf/hooks/useProductWiseSkuPdfData";
import {
  pageWrap,
  tableWrap,
} from "../Common/ProductWiseSkuPdf/styles/productWiseSkuPdfStyles";
import {
  getPdfDateRange,
  getSkuPdfLists,
} from "../Common/ProductWiseSkuPdf/utils/productWiseSkuPdfUtils";
import { fetchPurchaseOrderSkuWise } from "./PurchaseOrderProductWise/utils/purchaseOrderProductWiseApi";
import {
  getPurchaseOrderProductAllQty,
  getPurchaseOrderUomQty,
} from "./PurchaseOrderProductWise/utils/purchaseOrderQtyUtils";
import "../Billing History/billPDFCss.css";

// Place Order — SKU-wise purchase order print page.
const PurchaseOrderProductWisePDF = ({ showLoador, showNotification }) => {
  const { billList } = useProductWiseSkuPdfData({
    showLoador,
    showNotification,
    fetchData: fetchPurchaseOrderSkuWise,
  });

  if (Object.keys(billList).length == 0) {
    return null;
  }

  const { dateLabel } = getPdfDateRange();
  const { categoryWithProducts, uomList, orderSummaries } =
    getSkuPdfLists(billList);

  return (
    <>
      <div style={pageWrap}>
        <ProductWiseSkuPdfHeader
          title={
            langugae[2].purchaseOrderSummary
              ? langugae[2].purchaseOrderSummary
              : ""
          }
          billList={billList}
          dateLabel={dateLabel}
          showBeatName={false}
        />

        <div style={tableWrap}>
          <ProductWiseSkuPdfTable
            billList={billList}
            dateLabel={dateLabel}
            categoryWithProducts={categoryWithProducts}
            uomList={uomList}
            orderSummaries={orderSummaries}
            getUomQty={getPurchaseOrderUomQty}
            getProductAllQty={getPurchaseOrderProductAllQty}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PurchaseOrderProductWisePDF);
